import axios from "axios";
import { IBooking } from "../../types";
import { ICreateBookingApiParams } from "../types";

interface IBookParams extends Omit<ICreateBookingApiParams, "draftData"> {
    id: string
}

interface IBookReturn extends IBooking {}

export const book = async ({ id, ...params }: IBookParams): Promise<IBookReturn> => {
    const response = await axios.post(`/booking/book/${id}/confirm`, params);
    return response.data;
};